export const common = {
  nav: {
    home: 'Startseite',
    about: 'Über Uns',
    services: 'Dienstleistungen',
    facility: 'Anlage & Sicherheit',
    blog: 'Wissenszentrum',
    contact: 'Kontakt',
    getQuote: 'Angebot Anfordern',
    callNow: 'Jetzt Anrufen',
    whatsapp: 'WhatsApp'
  },
  hero: {
    title: 'Zuverlässige Lager- und Logistikdienstleistungen mit Anbindung an Muratbey Zoll',
    subtitle: 'Schnelle, sichere und transparente Lösungen für Ihre Zoll-/Nicht-Zoll-Lagerung, Transit- und Logistikoperationen.',
    quickQuoteTitle: 'Schnelles Angebotsformular'
  },
  form: {
    fullName: 'Vollständiger Name',
    company: 'Firma',
    phone: 'Telefon',
    email: 'E-Mail',
    service: 'Dienstleistungsauswahl',
    message: 'Nachricht',
    kvkk: 'Ich habe die Datenschutzrichtlinie gelesen und akzeptiert',
    submit: 'Angebot Anfordern',
    selectService: 'Dienstleistung auswählen'
  },
  services: {
    title: 'Unsere Dienstleistungen',
    subtitle: 'Maßgeschneiderte Logistiklösungen',
    viewDetails: 'Details Anzeigen',
    customsWarehouse: {
      title: 'Zolllager',
      benefits: [
        'Einsparung von Einfuhrsteuern',
        '24/7 Online-Tracking-System',
        'Schnelle Zollverfahren'
      ]
    },
    freeWarehouse: {
      title: 'Freizone / Nicht-Zoll-Lagerung',
      benefits: [
        'Flexible Lagerzeiten',
        'Moderne Anlage und Ausrüstung',
        'Sichere Bestandsverwaltung'
      ]
    },
    transit: {
      title: 'Transitdienste',
      benefits: [
        'Schnelle Transitverfahren',
        'Internationale Erfahrung',
        'Umfassende Dokumentation'
      ]
    },
    hazardous: {
      title: 'Gefahrstofflager',
      benefits: [
        'Besondere Sicherheitsmaßnahmen',
        'Lizenzierte Lagerung',
        'Fachpersonal'
      ]
    },
    valueAdded: {
      title: 'Mehrwertdienste',
      benefits: [
        'Verpackung und Etikettierung',
        'Barcode-Systeme',
        'Konsolidierungsdienste'
      ]
    },
    customs: {
      title: 'Zollabfertigung',
      benefits: [
        'Professionelle Zollberatung',
        'Schnelle Bearbeitung',
        'Vollständige Compliance-Garantie'
      ]
    }
  },
  whyUs: {
    title: 'Warum Piramit?',
    subtitle: 'Vertrauens- und Qualitätsorientierter Service',
    quality: {
      title: 'Qualität und Vertrauen',
      desc: 'ISO 9001 Standardverfahren und kontinuierliche Verbesserung'
    },
    transparency: {
      title: 'Transparente Berichterstattung',
      desc: '24/7 Online-Tracking und detaillierte Bestandsverwaltung'
    },
    speed: {
      title: 'Schnelle Antwort',
      desc: 'Angebot innerhalb von 24 Stunden und schnelle Betriebsabläufe'
    },
    experience: {
      title: 'Erfahrung',
      desc: 'Zuverlässiger Service im Logistiksektor seit 1974'
    }
  },
  facility: {
    title: 'Anlage & Kapazität',
    subtitle: 'Moderne Infrastruktur und Technologie',
    totalArea: 'Insgesamt 5.000 m² Lagerfläche',
    customsArea: '2.800 m² Zolllager',
    freeArea: '2.200 m² Freizone',
    viewGallery: 'Unsere Anlage Ansehen'
  },
  security: {
    title: 'Sicherheit & Technologie',
    subtitle: 'Hochstandardschutz',
    camera: {
      title: '24/7 Kamerasystem',
      desc: 'Kontinuierliche Sicherheitsüberwachung'
    },
    alarm: {
      title: 'Alarmsystem',
      desc: 'Fortschrittliche Sicherheitsinfrastruktur'
    },
    fire: {
      title: 'Brandbekämpfung',
      desc: 'Automatisches Brandbekämpfungssystem'
    },
    wms: {
      title: 'WMS / ERP Integration',
      desc: 'Online-Bestandszugriff und -verwaltung'
    }
  },
  testimonials: {
    title: 'Kundenstimmen',
    subtitle: 'Ihr Vertrauenswürdiger Geschäftspartner'
  },
  cta: {
    title: 'Lassen Sie Uns Innerhalb von 24 Stunden Zurückkommen',
    subtitle: 'Holen Sie sich jetzt ein Angebot für Ihre Logistikbedürfnisse',
    getQuote: 'Angebot Anfordern',
    callUs: 'Rufen Sie Uns An'
  },
  contact: {
    hero: {
      title: 'Kontakt',
      subtitle: 'Wir sind 24/7 für Sie da. Kontaktieren Sie uns bei Fragen.'
    },
    info: {
      title: 'Kontaktinformationen',
      description: 'Sie können uns für detaillierte Informationen über unsere Logistik- und Lagerdienstleistungen kontaktieren.',
      address: {
        title: 'Adresse',
        content: 'Taşocağı Cad. No:26 Mahmutbey 34670 Bağcılar / Istanbul / TÜRKEI'
      },
      phone: {
        title: 'Telefon'
      },
      fax: {
        title: 'Fax'
      },
      email: {
        title: 'E-Mail'
      },
      whatsapp: {
        title: 'WhatsApp'
      },
      workingHours: {
        title: 'Arbeitszeiten',
        weekdays: 'Montag - Freitag: 08:30 - 17:00',
        saturday: 'Samstag: Geschlossen',
        sunday: 'Sonntag: Geschlossen'
      },
      qrCode: 'QR-Code scannen für schnellen Kontakt'
    },
    form: {
      title: 'Schreiben Sie Uns',
      description: 'Sie können uns erreichen, indem Sie das Formular ausfüllen. Wir werden uns so schnell wie möglich bei Ihnen melden.',
      name: 'Vollständiger Name / Firmenname',
      namePlaceholder: 'Geben Sie Ihren Namen ein',
      email: 'E-Mail',
      emailPlaceholder: 'beispiel@email.com',
      phone: 'Telefon / Ihre Nachricht',
      phonePlaceholder: 'Ihre Telefonnummer',
      message: 'Ihre Nachricht',
      messagePlaceholder: 'Schreiben Sie Ihre Nachricht hier...',
      characters: 'Zeichen',
      submit: 'Senden',
      sending: 'Wird gesendet...',
      successMessage: 'Ihre Nachricht wurde erfolgreich gesendet! Wir werden uns so schnell wie möglich bei Ihnen melden.',
      errorMessage: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.'
    },
    map: {
      title: 'Standort',
      subtitle: 'Sie können eine Wegbeschreibung von der Karte erhalten, um unsere Anlage zu besuchen'
    }
  },
  infoCenter: {
    hero: {
      title: 'Wissenszentrum',
      subtitle: 'Erhalten Sie detaillierte Informationen über Zolllagervorschriften und erforderliche Dokumente'
    },
    sections: {
      regulations: {
        title: 'Vorschriften und Richtlinien',
        description: 'Aktuelle Vorschriften und Richtlinien im Zusammenhang mit Zolllageroperationen'
      },
      notifications: {
        title: 'Allgemeine Benachrichtigungen',
        description: 'Offizielle Benachrichtigungen und Updates zum Zolllagerregime'
      },
      forms: {
        title: 'Antragsformulare',
        description: 'Erforderliche Formulare und Dokumente für Lagereröffnung und -betrieb'
      }
    },
    documents: {
      download: 'Herunterladen',
      viewAll: 'Alle Anzeigen'
    }
  },
  footer: {
    contact: 'Kontakt',
    address: 'Taşocağı Cad. No:26 Mahmutbey 34670 Bağcılar / Istanbul / TÜRKEI',
    phone: 'Telefon',
    fax: 'Fax',
    email: 'E-Mail',
    quickLinks: 'Schnelllinks',
    workingHours: 'Arbeitszeiten',
    weekdays: 'Montag - Freitag: 08:30 - 17:00',
    saturday: 'Samstag: Geschlossen',
    sunday: 'Sonntag: Geschlossen',
    copyright: '© 2025 Piramit Lager & Logistik. Alle Rechte vorbehalten.',
    poweredBy: 'Web Design'
  }
};

export default common;